import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * StatusLoading - Calm loading state for membership resolution.
 */
export function StatusLoading() {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        color: 'text.secondary',
      }}
    >
      <CircularProgress size={24} thickness={4} aria-label="Loading status" />
      <Typography variant="caption">Checking your status...</Typography>
    </Box>
  );
}
